import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const StreakCalendarLegend = () => {
  const theme = useStatsTheme((s) => s.theme)
  const year = useStats((s) => s.year)
  const bgColors = theme.colors.charts.momStreaks

  const details = [
    {
      color: bgColors.bestStreak.bg,
      label: `Best ${year} streak`,
    },
    {
      color: bgColors.daysRead.bg,
      label: 'Days read',
    },
    {
      color: bgColors.cellBg,
      label: 'No reading',
    },
  ]

  return (
    <FlexBox
      className={css`
        gap: 9%;
      `}
    >
      {details.map((detail, i) => (
        <div key={i}>
          <span
            className={css`
              margin-bottom: 2px;
              display: block;
              width: 16px;
              height: 12px;
              border-radius: 4px;
              background-color: ${detail.color};
            `}
          />
          <Text
            className={css`
              margin-bottom: -2px;
            `}
            type="label"
            sizing="L"
            weight="500"
            color={theme.colors.section.legend.text}
          >
            {detail.label}
          </Text>
        </div>
      ))}
    </FlexBox>
  )
}
